const fixDataTypes = sheetAsJson =>
  sheetAsJson.map(tlsAccount => ({
    ...tlsAccount,
    account: `${tlsAccount.account}`,
  }));

export default fixDataTypes;
